// @flow

/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

import * as DSToken from './DSToken';

export default {
  BACKGROUND_COLOR_CONTRAST: DSToken.BACKGROUND_COLOR_CONTRAST,
  BACKGROUND_COLOR_OVERLAY: DSToken.BACKGROUND_COLOR_OVERLAY,
  BACKGROUND_COLOR_OVERLAY_ACCENT: DSToken.BACKGROUND_COLOR_OVERLAY_ACCENT,
  BACKGROUND_COLOR_TERTIARY: DSToken.BACKGROUND_COLOR_TERTIARY,
  BACKGROUND_COLOR_SECONDARY: DSToken.BACKGROUND_COLOR_SECONDARY,
  BACKGROUND_COLOR_PRIMARY: DSToken.BACKGROUND_COLOR_PRIMARY,
  BACKGROUND_COLOR_ERROR: DSToken.BACKGROUND_COLOR_ERROR,
  BACKGROUND_COLOR_ACCENT: DSToken.BACKGROUND_COLOR_ACCENT,
  BORDER_COLOR_PRIMARY: DSToken.BORDER_COLOR_PRIMARY,
  BORDER_COLOR_SECONDARY: DSToken.BORDER_COLOR_SECONDARY,
  BORDER_COLOR_ERROR: DSToken.BORDER_COLOR_ERROR,
  BORDER_COLOR_INPUT_FOCUS: DSToken.BORDER_COLOR_INPUT_FOCUS,
  INTERACTIVE_TEXT_COLOR_PRIMARY: DSToken.INTERACTIVE_TEXT_COLOR_PRIMARY,
  INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE: DSToken.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE,
  INTERACTIVE_TEXT_COLOR_DISABLED: DSToken.INTERACTIVE_TEXT_COLOR_DISABLED,
  INTERACTIVE_TEXT_COLOR_LINK_PRIMARY: DSToken.INTERACTIVE_TEXT_COLOR_LINK_PRIMARY,
  INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED: DSToken.INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED,
  INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE: DSToken.INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE,
  INTERACTIVE_TEXT_COLOR_LINK_SECONDARY: DSToken.INTERACTIVE_TEXT_COLOR_LINK_SECONDARY,
  INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED:
    DSToken.INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED,
  INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE:
    DSToken.INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE,
  INTERACTIVE_BORDER_COLOR_PRIMARY: DSToken.INTERACTIVE_BORDER_COLOR_PRIMARY,
  INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED: DSToken.INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED,
  INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE: DSToken.INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE,
  INTERACTIVE_BORDER_COLOR_DISABLED: DSToken.INTERACTIVE_BORDER_COLOR_DISABLED,
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY: DSToken.INTERACTIVE_BACKGROUND_COLOR_PRIMARY,
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED:
    DSToken.INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED,
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE: DSToken.INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE,
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED:
    DSToken.INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED,
  INTERACTIVE_BACKGROUND_COLOR_DISABLED: DSToken.INTERACTIVE_BACKGROUND_COLOR_DISABLED,
  SEPARATOR_COLOR_PRIMARY: DSToken.SEPARATOR_COLOR_PRIMARY,
  TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED:
    DSToken.TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED,
  TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED:
    DSToken.TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED,
  TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND:
    DSToken.TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND,
  TEXT_COLOR_PRIMARY: DSToken.TEXT_COLOR_PRIMARY,
  TEXT_COLOR_PRIMARY_INVERSE: DSToken.TEXT_COLOR_PRIMARY_INVERSE,
  TEXT_COLOR_SECONDARY: DSToken.TEXT_COLOR_SECONDARY,
  TEXT_COLOR_SECONDARY_INVERSE: DSToken.TEXT_COLOR_SECONDARY_INVERSE,
  TEXT_COLOR_TERTIARY: DSToken.TEXT_COLOR_TERTIARY,
  TEXT_COLOR_TERTIARY_INVERSE: DSToken.TEXT_COLOR_TERTIARY_INVERSE,
  TEXT_COLOR_DISABLED: DSToken.TEXT_COLOR_DISABLED,
  TEXT_COLOR_PLACEHOLDER: DSToken.TEXT_COLOR_PLACEHOLDER,
  TEXT_COLOR_ERROR: DSToken.TEXT_COLOR_ERROR,
  TEXT_COLOR_PRICE: DSToken.TEXT_COLOR_PRICE,
  GRADIENT_BASE: DSToken.GRADIENT_BASE,
  GRADIENT_PRIMARY: DSToken.GRADIENT_PRIMARY,
  GRADIENT_PRIMARY_PRESSED: DSToken.GRADIENT_PRIMARY_PRESSED,
  GRADIENT_DESTRUCTIVE: DSToken.GRADIENT_DESTRUCTIVE,
  GRADIENT_DESTRUCTIVE_PRESSED: DSToken.GRADIENT_DESTRUCTIVE_PRESSED,
  BORDER_RADIUS: DSToken.BORDER_RADIUS,
  SPACE_0X: DSToken.SPACE_0X,
  SPACE_1X: DSToken.SPACE_1X,
  SPACE_2X: DSToken.SPACE_2X,
  SPACE_3X: DSToken.SPACE_3X,
  SPACE_4X: DSToken.SPACE_4X,
  SPACE_5X: DSToken.SPACE_5X,
  SPACE_6X: DSToken.SPACE_6X,
  SPACE_8X: DSToken.SPACE_8X,
  SPACE_12X: DSToken.SPACE_12X,
  SPACE_16X: DSToken.SPACE_16X,
  SPACE_24X: DSToken.SPACE_24X,
  HEADING_100_FONT_FAMILY: DSToken.HEADING_100_FONT_FAMILY,
  HEADING_100_FONT_SIZE: DSToken.HEADING_100_FONT_SIZE,
  HEADING_100_FONT_WEIGHT: DSToken.HEADING_100_FONT_WEIGHT,
  HEADING_100_LINE_HEIGHT: DSToken.HEADING_100_LINE_HEIGHT,
  HEADING_100_MARGIN_BOTTOM: DSToken.HEADING_100_MARGIN_BOTTOM,
  HEADING_200_FONT_FAMILY: DSToken.HEADING_200_FONT_FAMILY,
  HEADING_200_FONT_SIZE: DSToken.HEADING_200_FONT_SIZE,
  HEADING_200_FONT_WEIGHT: DSToken.HEADING_200_FONT_WEIGHT,
  HEADING_200_LINE_HEIGHT: DSToken.HEADING_200_LINE_HEIGHT,
  HEADING_200_MARGIN_BOTTOM: DSToken.HEADING_200_MARGIN_BOTTOM,
  HEADING_300_FONT_FAMILY: DSToken.HEADING_300_FONT_FAMILY,
  HEADING_300_FONT_SIZE: DSToken.HEADING_300_FONT_SIZE,
  HEADING_300_FONT_WEIGHT: DSToken.HEADING_300_FONT_WEIGHT,
  HEADING_300_LINE_HEIGHT: DSToken.HEADING_300_LINE_HEIGHT,
  HEADING_300_MARGIN_BOTTOM: DSToken.HEADING_300_MARGIN_BOTTOM,
  HEADING_400_FONT_FAMILY: DSToken.HEADING_400_FONT_FAMILY,
  HEADING_400_FONT_SIZE: DSToken.HEADING_400_FONT_SIZE,
  HEADING_400_FONT_WEIGHT: DSToken.HEADING_400_FONT_WEIGHT,
  HEADING_400_LINE_HEIGHT: DSToken.HEADING_400_LINE_HEIGHT,
  HEADING_400_MARGIN_BOTTOM: DSToken.HEADING_400_MARGIN_BOTTOM,
  HEADING_500_FONT_FAMILY: DSToken.HEADING_500_FONT_FAMILY,
  HEADING_500_FONT_SIZE: DSToken.HEADING_500_FONT_SIZE,
  HEADING_500_FONT_WEIGHT: DSToken.HEADING_500_FONT_WEIGHT,
  HEADING_500_LINE_HEIGHT: DSToken.HEADING_500_LINE_HEIGHT,
  HEADING_500_MARGIN_BOTTOM: DSToken.HEADING_500_MARGIN_BOTTOM,
  HEADING_600_FONT_FAMILY: DSToken.HEADING_600_FONT_FAMILY,
  HEADING_600_FONT_SIZE: DSToken.HEADING_600_FONT_SIZE,
  HEADING_600_FONT_WEIGHT: DSToken.HEADING_600_FONT_WEIGHT,
  HEADING_600_LINE_HEIGHT: DSToken.HEADING_600_LINE_HEIGHT,
  HEADING_600_MARGIN_BOTTOM: DSToken.HEADING_600_MARGIN_BOTTOM,
  HEADING_RESPONSIVE_400_FONT_SIZE: DSToken.HEADING_RESPONSIVE_400_FONT_SIZE,
  HEADING_RESPONSIVE_500_FONT_SIZE: DSToken.HEADING_RESPONSIVE_500_FONT_SIZE,
  HEADING_RESPONSIVE_600_FONT_SIZE: DSToken.HEADING_RESPONSIVE_600_FONT_SIZE,
  PARAGRAPH_100_FONT_SIZE: DSToken.PARAGRAPH_100_FONT_SIZE,
  PARAGRAPH_100_FONT_WEIGHT: DSToken.PARAGRAPH_100_FONT_WEIGHT,
  PARAGRAPH_100_LINE_HEIGHT: DSToken.PARAGRAPH_100_LINE_HEIGHT,
  PARAGRAPH_100_MARGIN_BOTTOM: DSToken.PARAGRAPH_100_MARGIN_BOTTOM,
  PARAGRAPH_200_FONT_SIZE: DSToken.PARAGRAPH_200_FONT_SIZE,
  PARAGRAPH_200_FONT_WEIGHT: DSToken.PARAGRAPH_200_FONT_WEIGHT,
  PARAGRAPH_200_LINE_HEIGHT: DSToken.PARAGRAPH_200_LINE_HEIGHT,
  PARAGRAPH_200_MARGIN_BOTTOM: DSToken.PARAGRAPH_200_MARGIN_BOTTOM,
  PARAGRAPH_300_FONT_SIZE: DSToken.PARAGRAPH_300_FONT_SIZE,
  PARAGRAPH_300_FONT_WEIGHT: DSToken.PARAGRAPH_300_FONT_WEIGHT,
  PARAGRAPH_300_LINE_HEIGHT: DSToken.PARAGRAPH_300_LINE_HEIGHT,
  PARAGRAPH_300_MARGIN_BOTTOM: DSToken.PARAGRAPH_300_MARGIN_BOTTOM,
  TEXT_100_FONT_SIZE: DSToken.TEXT_100_FONT_SIZE,
  TEXT_100_FONT_WEIGHT: DSToken.TEXT_100_FONT_WEIGHT,
  TEXT_100_LINE_HEIGHT: DSToken.TEXT_100_LINE_HEIGHT,
  TEXT_200_FONT_SIZE: DSToken.TEXT_200_FONT_SIZE,
  TEXT_200_FONT_WEIGHT: DSToken.TEXT_200_FONT_WEIGHT,
  TEXT_200_LINE_HEIGHT: DSToken.TEXT_200_LINE_HEIGHT,
  TEXT_300_FONT_SIZE: DSToken.TEXT_300_FONT_SIZE,
  TEXT_300_FONT_WEIGHT: DSToken.TEXT_300_FONT_WEIGHT,
  TEXT_300_LINE_HEIGHT: DSToken.TEXT_300_LINE_HEIGHT,
};



// WEBPACK FOOTER //
// ../design-system/style-dictionary/build/es6/DSTokenMap.js